import { Injectable } from '@angular/core';
import { PowerBiGQL } from '@cpd-app/generated';
import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PowerBiService {
  constructor(private powerBiGQL: PowerBiGQL) {}

  /**
   * @returns embed configuration
   */
  public getEmbedConfig() {
    return this.powerBiGQL
      .fetch()
      .pipe(map((result) => result.data.getReportEmbedConfig));
  }
}
